import cn from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';

import * as colors from '../utils/color';
import type { CustomColor } from '../utils/color';

interface PillProps extends ComponentPropsWithoutRef<'div'> {
  color: CustomColor | string;
}

export default function Pill({ color, className, children }: PillProps) {
  return (
    <div
      style={{ background: color in colors ? colors[color as CustomColor] : color }}
      className={cn('px-3 py-1 text-xs tracking-wider uppercase rounded-full', className)}
    >
      {children}
    </div>
  );
}
